.headerBtn {
    margin: 0 30px;
    position: relative;
    font-size: 16px;
    font-family: var(--font-body);
    color: #B0B2C3;
    transition: color 0.3s ease;
    cursor: pointer;
    border: none;
    background-color: transparent;
    text-decoration: none;
    padding: 0;
}

.headerBtn::before {
    content: '';
    position: absolute;
    bottom: -5px;
    left: -100%;
    width: 0;
    height: 3px;
    border-radius: 2px;
    transition: width 0.3s ease, left 0.3s ease;
}

.headerBtn:hover {
    color: white;
}

@keyframes slideRight {
    0% {
        width: 0;
        left: 0;
        background: linear-gradient(to left, #2a5788, #357ABD);
    }
    100% {
        width: 100%;
        left: 0;
        background: linear-gradient(to left, #2a5788, #357ABD);
    }
}

.headerBtn:hover:before {
    width: 100%;
    left: 0;
    animation: slideRight 0.2s linear forwards;
}

.headerBtn:not(:hover):before {
    animation: slideRightReverse 0.2s linear forwards;
}


@keyframes slideRightReverse {
    0% {
        width: 100%;
        left: 0;
        background: linear-gradient(to left, #2a5788, #357ABD);
    }
    10% {
        width: 90%;
        left: 10%;
        background-color: #f25757;
    }
    100% {
        width: 0;
        background-color: #f25757;
        left: 100%;
    }
}

@media (max-width: 768px) {
    /* the padding makes the tap area 44px high */
    .headerBtn {
        margin: 0 9px;
        padding: 14px 0;
        font-size: 14px;
        white-space: nowrap;
    }

    .headerBtn::before {
        bottom: 9px;
    }
}
